import { useQuery } from "react-query"
import { normalFetch } from "../../../fetch-api/get"



const REWARD_KEYS = {
    GET_ALL_REWARD: 'get-all-reward',
}


const useGetAllReward = () => {

    return useQuery(
        REWARD_KEYS.GET_ALL_REWARD, () => normalFetch('rewards/admin'),
        {
            select: res => res?.data?.data
        }
    )
}




export {
    useGetAllReward,
}
